import { use, useEffect } from "react";
import { AuthContext } from "react-oauth2-code-pkce";
import { type IAuthContext } from "react-oauth2-code-pkce/dist/types";
import { useTranslation } from "react-i18next";
import { Card, Grid } from "@sede-enterprise/shell-ds-react-framework";
import { Container } from "../../components/SDS/Container";
import { Loader } from "../../components/Loader";
import "../../styles/App.css";

const Login = () => {
  const { token, logIn, error, loginInProgress }: IAuthContext =
    use(AuthContext);
  const { t } = useTranslation();

  useEffect(() => {
    // Auto-initiate login for users who land on the login page
    // Only if not currently processing and no errors
    if (!loginInProgress && !token && !error) {
      logIn();
    }
  }, [loginInProgress, token, error, logIn]);

  // Default state - show login initiation message
  return (
    <Container>
      <Grid columns={1} height="auto" flow="row" className="login-grid">
        <Grid.Cell>
          <Card className="login-card">
            <Loader
              message={t("auth.authenticating", "Authenticating...")}
              size="medium"
            />
          </Card>
        </Grid.Cell>
      </Grid>
    </Container>
  );
};

export default Login;
